import { requestJson } from "../api/apiClient";

const BASE = "/api/admin/weather/colombia/monitoring";

export async function fetchWeatherMonitoringSummary() {
  return requestJson(`${BASE}/summary`);
}

export async function fetchWeatherOperationalAlerts(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  const query = params.toString();
  return requestJson(`${BASE}/alerts${query ? `?${query}` : ""}`);
}

export async function runWeatherMonitoringCheck(body = {}) {
  return requestJson(`${BASE}/run`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function patchWeatherOperationalAlert(alertId, body) {
  return requestJson(`${BASE}/alerts/${encodeURIComponent(alertId)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export const ALERT_SEVERITY_ORDER = {
  critical: 1,
  warning: 2,
  info: 3,
};
